import React, { Component, useEffect, useState } from 'react'
import { createPaymentOrder, verifyOnboardingPayment } from '@/store/thunkMidddleware/paymentMiddleware'
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import Strings from '@/constants/String'
import { toast as newToast } from "@/components/ui/sonner";
import PaymentProcessing from "./paymentProcessing";
import { Loader2 } from 'lucide-react';
import { Dialog } from '@radix-ui/react-dialog';

const Payment = ({ venueId = null, plan = null, billingCycle = null, PaymentCloseHandler, PaymentSuccesshandler }) => {
    const dispatch = useAppDispatch()
    const [isProcessing, setIsProcessing] = useState(false)
    const [startPayment, setStartPayment] = useState(true)
    const [apiCountTime, setApiCountTime] = useState(0)

    const paymentSuccessHandler = (response: any, orderDetails: any) => {
        console.log(response);
        let timeout = null
        setIsProcessing(true)
        setStartPayment(false);
        newToast.success(`Payment successful, please don't refesh we are verifying your payment\nYour TxnID:${response.razorpay_payment_id}`, { closeButton: true })
        const { razorpay_order_id, razorpay_payment_id, razorpay_signature, } = response
        const venueId = orderDetails?.razorpayOrderDetails?.venueId
        timeout = setTimeout(() => {
            dispatch(verifyOnboardingPayment({
                payload: { razorpay_order_id, razorpay_payment_id, razorpay_signature, venueId }, callback: (res) => {
                    if (res?.payload) {
                        setIsProcessing(false)
                        clearTimeout(timeout)
                        PaymentSuccesshandler(res?.payload)
                    } else {
                        console.log("apiCountTime:", apiCountTime)
                        setApiCountTime(apiCountTime + 1)
                        paymentSuccessHandler(response, orderDetails)
                    }
                }
            }))
        }, 1000 * 2);
    }
    const paymentErrorHandler = (response: any) => {
        newToast.error(`Payment failed: ${response?.error?.description}`, { closeButton: true });

    }
    const createBookingHandler = async (venueId: string) => {
        let paymentPayload: Record<string, any> = {
            "venueId": venueId,
        }
        if (plan) {
            paymentPayload.plan = plan
            if (billingCycle) paymentPayload.billingCycle = billingCycle
        }
        dispatch(createPaymentOrder({
            payload: paymentPayload, callback: (orderDetails: any) => {
                if (orderDetails?.payload) {
                    const { key,
                        id,
                        amount,
                        currency,
                        prefill,
                        notes,
                        method
                    } = orderDetails?.payload?.razorpayOrderDetails
                    const options = {
                        key,
                        image: Strings.logoUrl,
                        amount,
                        method: method || {
                            upi: true,
                            card: false,
                            netbanking: false,
                            wallet: false,
                            emi: false,
                            paylater: false
                        },
                        currency,
                        order_id: id,
                        name: "BookYourZone",
                        description: "One-Time Onboardng Fee",
                        prefill,
                        notes,
                        timeout:Strings.paymentExpriryTime, // 15 min
                        theme: {
                            color: "#43b4b4"
                        },
                        handler: function (response: any) {
                            paymentSuccessHandler(response, orderDetails?.payload)
                        },
                        modal: {
                            ondismiss: () => {
                                console.warn("User closed the Razorpay checkout popup");
                                newToast.error("Opps!, Razorpay payment closed")
                                if (PaymentCloseHandler) {
                                    PaymentCloseHandler()
                                }
                                // You can call your error handler here
                                // setIsProcessing(true)

                                // dispatch(cancelBooking({
                                //     pathparams: bookingDetails?.payload?.bookingId, callback: (res) => {
                                //         if (res) {
                                //             toast("Booking cancelled successfully!");
                                //             paymentErrorHandler({ error: { description: "Checkout closed." } });
                                //             navigate(location?.state?.navigateto || -1)
                                //         }
                                //     }
                                // }))


                            }
                        }
                    };

                    const rzp: any = new window.Razorpay(options);

                    // 🔴 Error or close handler
                    (rzp as any).on('payment.failed', paymentErrorHandler);
                    // 🟡 Optional: Handle checkout modal dismissal
                    // (rzp as any).on('payment.cancelled', paymentErrorHandler);
                    rzp.open();

                    // setTimeout(() => {
                    //     rzp.close();
                    //     toast("Payment session expired. Please try booking again.");

                    // }, 5 * 60 * 1000);

                } else if (orderDetails?.payload) {

                }

            }
        }))
    }

    useEffect(() => {
        if (venueId) {
            createBookingHandler(venueId)
        } else {
            newToast.error("Payment page load failed required venueId,")
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            setStartPayment(false)
        }, 3000);
    })

    const renderProcessingModal = () => {
        return (
            <PaymentProcessing />
        )
    }
    return (
        <>
            {isProcessing && renderProcessingModal()}
            {
                startPayment && <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>  <Loader2 className="animate-spin w-12 h-12 text-orange-600" /></div>
            }

        </>
    )

}


export default Payment;


